import OperatorButton from 'components/OperatorButton';
import useControllerOperatorList from './_presenters/useControllerOperatorList/useControllerOperatorList';
import { Spinner } from 'reactstrap';
import claro from 'assets/images/claro 1.png';
import tim from 'assets/images/tim 1.png';
import vivo from 'assets/images/vivo 1.png';
import { useNavigate } from 'react-router-dom';
import { Operator } from '../../../models/Operator';
import { useMemo } from 'react';

export type OperatorListProps = {
  ddd: string;
  phone: string;
};
const OperatorList = ({ ddd, phone }: OperatorListProps) => {
  const { operadoras, isLoading } = useControllerOperatorList({ ddd });
  const navigate = useNavigate();

  const goToOperadora = (operadora: Operator) => {
    navigate(`/recarga?ddd=${ddd}&phone=${phone}&operator=${operadora.code}`);
  };

  const sortedByPriority = useMemo(
    () =>
      operadoras?.sort((a: Operator, b: Operator) => {
        const priorityOrder = [
          'TIM',
          'CLARO',
          'VIVO',
          'ALGAR TELECOM',
          'CORREIOS',
          'SERCOMTEL',
          'NEXTEL'
        ];
        const aPriority = priorityOrder.indexOf(a.name.toUpperCase());
        const bPriority = priorityOrder.indexOf(b.name.toUpperCase());
        if (aPriority === -1 && bPriority === -1) {
          return 0;
        }
        return aPriority - bPriority;
      }),
    [operadoras]
  );

  return (
    <div className="d-flex flex-column align-items-center mt-3">
      <p className="font-size-3 font-color fw-medium mb-5">
        Qual é a operadora?
      </p>
      {isLoading && <Spinner />}
      {sortedByPriority?.map((operator: any) => (
        <OperatorButton
          key={operator.id}
          name={operator.name}
          onClick={() => goToOperadora(operator)}
          logo={
            operator.name.toLowerCase().indexOf('claro') > -1
              ? claro
              : operator.name.toLowerCase().indexOf('tim') > -1
              ? tim
              : operator.name.toLowerCase().indexOf('vivo') > -1
              ? vivo
              : undefined
          }
        />
      ))}
    </div>
  );
};

export default OperatorList;
